import { FC } from 'react';
import { Button, Box, Modal as MuiModal, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Section } from '../section';

import { ModalProps } from './types';
import { styles } from './styles';

export const Modal: FC<ModalProps> = ({ open, handleClose }) => {
    const { t } = useTranslation();
    return (
        <MuiModal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box css={styles.modal}>
                <Section header={t('login_session_expired')}>
                    <Typography id="modal-modal-description">
                        {t('login_session_expired_log_back')}
                    </Typography>
                    <Button variant="contained" css={styles.cta} onClick={handleClose}>
                        {t('login_session_expired_close')}
                    </Button>
                </Section>
            </Box>
        </MuiModal>
    );
};
